module.exports = __webpack_public_path__ + "media/images/favicons/favicon-32x32-5f36de6a47928714eb38e71e9f4bbecc.png";